import { styled } from '@mui/material';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';

export const Toolbar = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: 16,
  marginBottom: 16,
});

export const ListArea = styled('div')({
  flex: 1,
  minWidth: 0,
  minHeight: 0,
});

export const HiddenFileInput = styled('input')({
  display: 'none',
});

export const ImportIcon = styled(FileUploadOutlinedIcon)(
  {
    fontSize: 20,
  },
  ({ theme }) => ({
    color: theme.palette.novotalk.$actionButtonColor,
  })
);

export const ExportIcon = styled(FileDownloadOutlinedIcon)(
  {
    fontSize: 20,
  },
  ({ theme }) => ({
    color: theme.palette.novotalk.$actionButtonColor,
  })
);

export const DeleteActionButton = styled('button')({
  background: 'none',
  border: 'none',
  cursor: 'pointer',
  padding: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});
